export const { VUE_APP_API_URL } = process.env;
export const ACCESSOIRE = 'Accessoire';
export const BAIE = 'Baie';
export const BANDEAU_PRISE_ELECTRIQUE = 'BandeauPriseElectrique';
export const CABLE_CUIVRE = 'CableCuivre';
export const CABLE_OPTIQUE = 'CableOptique';
export const COFFRET = 'Coffret';
export const CORDON_RJ45 = 'CordonRj45';
export const EMBASE_RJ45 = 'EmbaseRj45';
export const GESTION_CABLE = 'GestionCable';
export const JARRETIERE = 'Jarretiere';
export const ONDULEUR = 'Onduleur';
export const PANNEAU_BRASSAGE = 'PanneauBrassage';
export const PLATEAU = 'Plateau';
export const TIROIR_OPTIQUE = 'TiroirOptique';
export const SWITCH = 'Switch';

export const PRODUCT_TYPES = [
  ACCESSOIRE,
  BAIE,
  BANDEAU_PRISE_ELECTRIQUE,
  CABLE_CUIVRE,
  CABLE_OPTIQUE,
  COFFRET,
  CORDON_RJ45,
  EMBASE_RJ45,
  GESTION_CABLE,
  JARRETIERE,
  ONDULEUR,
  PANNEAU_BRASSAGE,
  PLATEAU,
  TIROIR_OPTIQUE,
];

export const FILTER_FOR_TYPES = {
  [CABLE_CUIVRE]: [{
    name: 'Catégorie',
    filterStoreName: 'categorieRj45',
    filterProductAttribute: 'productable.categorie',
  }],
  [CORDON_RJ45]: [{
    name: 'Catégorie',
    filterStoreName: 'categorieRj45',
    filterProductAttribute: 'productable.categorie',
  }, {
    name: 'Longueur',
    filterStoreName: 'longueurCordonRj45',
    filterProductAttribute: 'productable.longueur',
  }],
  [EMBASE_RJ45]: [{
    name: 'Catégorie',
    filterStoreName: 'categorieRj45',
    filterProductAttribute: 'productable.categorie',
  }],
  [JARRETIERE]: [{
    name: 'Longueur',
    filterStoreName: 'longueurJarretiere',
    filterProductAttribute: 'productable.longueur',
  }, {
    name: 'Connecteur 1',
    filterStoreName: 'connecteurOptique',
    filterProductAttribute: 'productable.connecteur_1',
  }, {
    name: 'Connecteur 2',
    filterStoreName: 'connecteurJarretiere',
    filterProductAttribute: 'productable.connecteur_2',
  }, {
    name: 'Catégorie',
    filterStoreName: 'categorieOptique',
    filterProductAttribute: 'productable.categorie',
  }],
  [ONDULEUR]: [{
    name: 'Puissance en VA',
    filterStoreName: 'puissanceOnduleur',
    filterProductAttribute: 'productable.puissance_en_va',
  }],
  [TIROIR_OPTIQUE]: [{
    name: 'Nb traversées optiques',
    filterStoreName: 'nombreDeTraverseesTiroirOptique',
    filterProductAttribute: 'productable.nombre_de_traversees',
  }, {
    name: 'Catégorie',
    filterStoreName: 'categorieOptique',
    filterProductAttribute: 'productable.categorie',
  }, {
    name: 'Connecteur',
    filterStoreName: 'connecteurOptique',
    filterProductAttribute: 'productable.traversee',
  }, {
    name: 'Type de traversée',
    filterStoreName: 'typeDeTraverseeTiroirOptique',
    filterProductAttribute: 'productable.type_de_traversee',
  }],
  [SWITCH]: [{
    name: 'Nombre de ports 10/100',
    filterStoreName: 'switchNombreDePorts10100',
    filterProductAttribute: 'productable.nombre_de_ports_10_100',
  }, {
    name: 'Nombre de ports Gigabit',
    filterStoreName: 'switchNombreDePortsGigabit',
    filterProductAttribute: 'productable.nombre_de_ports_gigabit',
  }, {
    name: 'Nombre de ports SFP Gigabit',
    filterStoreName: 'switchNombreDePortsSFPGigabit',
    filterProductAttribute: 'productable.nombre_de_ports_fibre_sfp_gigabit',
  }, {
    name: 'Nombre de ports POE',
    filterStoreName: 'switchNombreDePortsPOE',
    filterProductAttribute: 'productable.nombre_de_ports_poe',
  }, {
    name: 'Manageable',
    filterStoreName: 'switchManageable',
    filterProductAttribute: 'productable.manageable',
  }],
  [BAIE]: [{
    name: 'Hauteur',
    filterStoreName: 'hauteurBaie',
    filterProductAttribute: 'taille',
  }, {
    name: 'Largeur',
    filterStoreName: 'largeurBaie',
    filterProductAttribute: 'productable.largeur',
  }, {
    name: 'Profondeur',
    filterStoreName: 'profondeurBaie',
    filterProductAttribute: 'productable.profondeur',
  }],
  [COFFRET]: [{
    name: 'Hauteur',
    filterStoreName: 'hauteurCoffret',
    filterProductAttribute: 'taille',
  }, {
    name: 'Largeur',
    filterStoreName: 'largeurCoffret',
    filterProductAttribute: 'productable.largeur',
  }, {
    name: 'Profondeur',
    filterStoreName: 'profondeurCoffret',
    filterProductAttribute: 'productable.profondeur',
  }],
};

export const ACTIVITIES = [
  'Aménageur de bureaux',
  'Électricien',
  'Installateur Courant Fort/Courant Faible',
  'Distributeur',
  'Autre',
];

export const COLOR_FOR_TYPE = {
  [ACCESSOIRE]: 'accessoire',
  [BANDEAU_PRISE_ELECTRIQUE]: 'electricite',
  [CORDON_RJ45]: 'cuivre',
  [EMBASE_RJ45]: 'cuivre',
  [GESTION_CABLE]: 'baie',
  [JARRETIERE]: 'optique',
  [ONDULEUR]: 'electricite',
  [PANNEAU_BRASSAGE]: 'cuivre',
  [PLATEAU]: 'baie',
  [SWITCH]: 'reseau',
  [TIROIR_OPTIQUE]: 'optique',
};

export const NAMES_FOR_TYPE = {
  [ACCESSOIRE]: 'Vis et accessoires',
  [BANDEAU_PRISE_ELECTRIQUE]: 'Bandeaux de prises électriques',
  [CORDON_RJ45]: 'Cordons RJ45',
  [EMBASE_RJ45]: 'Embases RJ45',
  [GESTION_CABLE]: 'Gestion de câble',
  [JARRETIERE]: 'Jarretières optiques',
  [ONDULEUR]: 'Onduleurs',
  [PANNEAU_BRASSAGE]: 'Panneaux de brassage',
  [PLATEAU]: 'Plateaux',
  [SWITCH]: 'Switches ethernet',
  [TIROIR_OPTIQUE]: 'Tiroirs optiques',
};

export const ATTRIBUTES_FOR_TYPE = {
  [ACCESSOIRE]: [{
    title: 'Nombre de ventilateurs',
    path: 'productable.nombre_de_ventilateur',
  }, {
    title: "Tension d'entrée",
    path: 'productable.tension_entree',
  }, {
    title: 'Adapté à',
    path: 'productable.adapte_a',
  }, {
    title: 'Epaisseur de la tole (mm)',
    path: 'productable.epaisseur_de_la_tole',
  }],
  [BANDEAU_PRISE_ELECTRIQUE]: [{
    title: 'Nombre de prises CEE 7/5 2P+T',
    path: 'productable.nombre_de_prises_cee',
  }, {
    title: 'Interupteur',
    path: 'productable.interrupteur',
  }, {
    title: 'Voyant',
    path: 'productable.voyant',
  }, {
    title: 'Tension typique',
    path: 'productable.tension_typique',
  }],
  [CORDON_RJ45]: [{
    title: 'Blindage général',
    path: 'productable.blindage_general',
  }, {
    title: 'Blindage paires',
    path: 'productable.blindage_paires',
  }, {
    title: 'Fréquence',
    path: 'productable.frequence',
  }, {
    title: 'Gaine',
    path: 'productable.gaine',
  }, {
    title: 'Jauge du conducteur',
    path: 'productable.jauge_du_conducteur',
  }, {
    title: 'Conducteur',
    path: 'productable.conducteur',
  }],
  [EMBASE_RJ45]: [{
    title: 'Catégorie',
    path: 'productable.categorie',
  }, {
    title: 'Blindage',
    path: 'productable.blindage',
  }, {
    title: 'Type de conenxion',
    path: 'productable.type_de_connexion',
  }, {
    title: 'Convient pour câble Jauge',
    path: 'productable.convient_pour_cable_jauge',
  }, {
    title: 'Contact',
    path: 'productable.contact',
  }],
  [GESTION_CABLE]: [{
    title: 'Fixation',
    path: 'productable.fixation',
  }, {
    title: 'Matière',
    path: 'productable.matiere',
  }],
  [JARRETIERE]: [{
    title: 'Mode de communication',
    path: 'productable.mode_de_communication',
  }, {
    title: 'Mode d\'échange',
    path: 'productable.mode_echange',
  }, {
    title: 'Catégorie',
    path: 'productable.categorie',
  }, {
    title: 'Diamètre fibre',
    path: 'productable.diametre_fibre',
  }, {
    title: 'Gaine',
    path: 'productable.gaine',
  }, {
    title: 'Couleur gaine',
    path: 'productable.couleur_gaine',
  }],
  [ONDULEUR]: [{
    title: 'Puissance en VA',
    path: 'productable.puissance_en_va',
  }, {
    title: 'Puissance en W',
    path: 'productable.puissance_en_w',
  }, {
    title: 'Technologie',
    path: 'productable.technologie',
  }, {
    title: 'Nombre de prises ondulées',
    path: 'productable.nombre_de_prises_ondulees',
  }, {
    title: 'Poids en KGs',
    path: 'productable.poids',
  }],
  [PANNEAU_BRASSAGE]: [{
    title: 'Nombre de ports',
    path: 'productable.nombre_de_ports',
  }, {
    title: 'Blindage',
    path: 'productable.blindage',
  }, {
    title: 'Catégorie',
    path: 'productable.categorie_reseau',
  }, {
    title: 'Utilisation',
    path: 'productable.utilisation',
  }, {
    title: 'Matière',
    path: 'productable.matiere',
  }],
  [PLATEAU]: [{
    title: 'Profondeur en mm',
    path: 'productable.profondeur',
  }, {
    title: 'Charge Max',
    path: 'productable.charge_max',
  }, {
    title: 'Utilisation',
    path: 'productable.utilisation',
  }, {
    title: 'Fixation',
    path: 'productable.fixation',
  }],
  [SWITCH]: [{
    title: 'Nombtre total de ports utilisables simultanément',
    path: 'productable.nombre_de_ports_simultanes',
  }, {
    title: 'Nombre de ports Fibre SFP Gigabit',
    path: 'productable.nombre_de_ports_sfp_gigabit',
  }, {
    title: 'Nombre de ports POE',
    path: 'productable.nombre_de_ports_poe',
  }, {
    title: 'Norme POE',
    path: 'productable.norme_poe',
  }, {
    title: 'Puissance Max par Port',
    path: 'productable.puissance_max_par_port',
  }, {
    title: 'Puissance POE Totale',
    path: 'productable.puissance_poe_totale',
  }],
  [TIROIR_OPTIQUE]: [{
    title: 'Nombre de Traversées',
    path: 'productable.nombre_de_traversees',
  }, {
    title: 'Nombre de fibres',
    path: 'productable.nombre_de_fibres',
  }, {
    title: 'Type de tiroir',
    path: 'productable.type_de_tiroir',
  }, {
    title: 'Cassette de lovage',
    path: 'productable.cassette_de_lovage',
  }, {
    title: 'Presse Etoupe',
    path: 'productable.presse_etoupe',
  }],
  [BAIE]: [{
    title: 'Largeur en mm',
    path: 'productable.largeur',
  },
  {
    title: 'Profondeur en mm',
    path: 'productable.profondeur',
  },
  {
    title: 'Taille',
    path: 'taille',
  }],
  [COFFRET]: [{
    title: 'Largeur en mm',
    path: 'productable.largeur',
  },
  {
    title: 'Profondeur en mm',
    path: 'productable.profondeur',
  },
  {
    title: 'Taille',
    path: 'taille',
  }],
};

export const TYPES_DE_GAINE = [
  'Câble intérieur / extérieur classique 900µm LSZH',
  'Câble intérieur / extérieur renforcé rongeurs 900µm LSZH - Belden',
  'Câble à structure libre gaine LSZH',
  'Câble à structure libre armé acier anti rongeurs gaine LSZH',
  'Câble à structure Break Out 2mm gaine LSZH',
];

export const LENGTH_BY_GAINE = {
  [TYPES_DE_GAINE[0]]: {
    min: 5,
    max: 2000,
  },
  [TYPES_DE_GAINE[1]]: {
    min: 5,
    max: 2000,
  },
  [TYPES_DE_GAINE[2]]: {
    min: 15,
    max: 2000,
  },
  [TYPES_DE_GAINE[3]]: {
    min: 15,
    max: 2000,
  },
  [TYPES_DE_GAINE[4]]: {
    min: 2,
    max: 75,
  },
};

export const CARACTERISTIQUES_GAINES = {
  'Câble intérieur / extérieur classique 900µm LSZH': {
    description: "Fibre mixte pour toutes vos installations en intérieur et en extérieur sous fourreau. D'un bon rapport qualité prix, cette fibre économique convient pour tous types de chantiers à faible niveau de contrainte.",
    antiFeu: 3,
    antiRongeur: 1,
    legerete: 4,
    resistance: 2,
    tirage: 2,
  },
  'Câble intérieur / extérieur renforcé rongeurs 900µm LSZH - Belden': {
    description: 'Fibre haut de gamme, recommandée pour les installations en ERP grâce à sa gaine équivalent norme C1 (IEC60332-3-24). Totalement diélectrique, convient particulièrement aux environnements difficiles et aux milieux hostiles à la fibre optique. Dispose de 4 fois plus de mèche de verre (anti-rongeurs) que la fibre structure serrée standard.',
    antiFeu: 4,
    antiRongeur: 3,
    legerete: 3,
    resistance: 4,
    tirage: 3,
  },
  'Câble à structure libre gaine LSZH': {
    description: 'Fibre qui, de par sa constitution et sa légèreté est particulièrement adaptée aux longues distances. Sa rigidité lui assure un bon maintient pour une installation sous fourreaux.',
    antiFeu: 3,
    antiRongeur: 2,
    legerete: 5,
    resistance: 1,
    tirage: 4,
  },
  'Câble à structure libre armé acier anti rongeurs gaine LSZH': {
    description: "Fibre dotée d'une très haute protection contre les rongeurs. Celle-ci est particulièrtemlent recommandée pour les environement ruraux. Possibilité d'enfouissement direct dans un environnement peu humide. Sa grande rigidité lui assure un bon maintien pour une installation facilitée sous fourreaux.",
    antiFeu: 3,
    antiRongeur: 5,
    legerete: 1,
    resistance: 5,
    tirage: 5,
  },
  'Câble à structure Break Out 2mm gaine LSZH': {
    description: 'Fibre destinée à la connexion inter-baies. Robuste grâce à sa double gaine, elle autorise une connexion directe sur les équipements actifs sans avoir recours à un tiroir optique.  Attention cependant son poids au mètre linéaire ne la rend pas appropriée pour les grandes longueurs.',
    antiFeu: 3,
    antiRongeur: 0,
    legerete: 1,
    resistance: 3,
    tirage: 'NC',
  },
};

export const RATING_ICONS = {
  antiFeu: {
    picto: 'anti-feu.svg',
    name: 'Anti-feu',
  },
  antiRongeur: {
    picto: 'anti-rongeur.svg',
    name: 'Anti-rongeurs',
  },
  legerete: {
    picto: 'legerete.svg',
    name: 'Légereté',
  },
  resistance: {
    picto: 'resistance.svg',
    name: 'Résistance',
  },
  tirage: {
    picto: 'tirage.svg',
    name: 'Facilité au tirage',
  },
};

export const TYPES_DE_FIBRE = [
  'OM1',
  'OM2',
  'OM3',
  'OM4',
  'OS2',
];

export const NOMBRE_DE_BRINS = [2, 4, 6, 12, 24, 48];

export const OS2_CONNECTEURS = ['LC/APC', 'SC/APC'];

export const CONNECTEURS_A = [
  'SC',
  'LC',
  'ST',
].concat(OS2_CONNECTEURS);

export const CONNECTEURS_B = CONNECTEURS_A.concat(['NU']);

export const AVAILABLE_FORM_OPTIONS = {
  [TYPES_DE_FIBRE[0]]: {
    [TYPES_DE_GAINE[0]]: [2, 4, 6],
    [TYPES_DE_GAINE[1]]: [2, 4, 6, 12, 24],
  },
  [TYPES_DE_FIBRE[1]]: {
    [TYPES_DE_GAINE[0]]: [2, 4, 6],
    [TYPES_DE_GAINE[1]]: [2, 4, 6, 12, 24],
  },
  [TYPES_DE_FIBRE[2]]: {
    [TYPES_DE_GAINE[0]]: [2, 4, 6, 12, 24, 48],
    [TYPES_DE_GAINE[1]]: [2, 4, 6, 12, 24],
    [TYPES_DE_GAINE[2]]: [4, 6, 12, 24],
    [TYPES_DE_GAINE[3]]: [4, 6, 12, 24],
    [TYPES_DE_GAINE[4]]: [4, 6, 12, 24],
  },
  [TYPES_DE_FIBRE[3]]: {
    [TYPES_DE_GAINE[0]]: [2, 4, 6, 12, 24, 48],
    [TYPES_DE_GAINE[1]]: [2, 4, 6, 12, 24],
    [TYPES_DE_GAINE[2]]: [4, 6, 12, 24],
    [TYPES_DE_GAINE[3]]: [4, 6, 12, 24],
    [TYPES_DE_GAINE[4]]: [4, 6, 12, 24],
  },
  [TYPES_DE_FIBRE[4]]: {
    [TYPES_DE_GAINE[0]]: [2, 4, 6, 12, 24, 48],
    [TYPES_DE_GAINE[1]]: [2, 4, 6, 12, 24],
    [TYPES_DE_GAINE[2]]: [4, 6, 12, 24, 48],
    [TYPES_DE_GAINE[3]]: [4, 6, 12, 24],
    [TYPES_DE_GAINE[4]]: [4, 6, 12, 24],
  },
};

export const TOOLTIP_FOR_OPTIONS = {
  refelctometrie: "Le test de réflectométrie est parfois exigé dans le cahier des charges ou le CCTP du client. Ce test permet de générer un rapport détaillé de plusieurs pages, ainsi qu'un graphique technique de la valeur d'atténuation et de réflectance de chaque évènement. Ce test est stocké pendant 1 an par nos soins. Une copie de celui-ci peut être obtenue par simple demande pendant 1 an à compter de la commande.",
  photometrie: "Par défaut, nous livrons systématiquement toutes nos liaisons préconnectorisées avec un rapport de test de photométrie. Il s'agit d'un test simple permettant de déterminer la valeur d'atténuation de la liaison globale. Ce test est à conserver précieusement par le client. Contrairement à la réflectométrie, ce test n'est pas stocké par nos soins. Il ne pourra donc être délivré aucune copie postérieurement à la commande.",
  regainage: 'Le regainage des brins en 3 mm permet de renforcer les extrémités de votre liaison préconnectorisée et ainsi de pouvoir la raccorder directement sur le matériel actif, sans passer par un tiroir optique.',
  chaussette: "Par défaut, nous équipons toutes nos préconnectorisations optiques avec une chaussette de tirage équipée d'un anneau de tirage. L'option deuxième chaussette est particulièrement adaptée pour les liaisons de grande longueur. En effet, cela permet alors le déploiement par le centre, de part et d'autre simultanément. Ainsi vous pourrez tirer sur les 2 extrémités pour gagner du temps et faciliter votre installation.",
  livraison: "Uniformatic s'engage à expédier votre liaison préconnectorisée sous 48h. Pour cette option nous utilisons exclusivement des transport express. Comptez alors 24 heures de délai d'acheminement. Si nous n'avons pas pu expédier votre commande sous 48 heures, nous vous remboursons l'intégralité du prix des frais de port express. (Attention, cette option n'est compatible qu' avec une sélection de références proposées par le configurateur UNI-Trunk®).",
};
